import { useQuery } from '@tanstack/react-query';
import { v1Get } from '@/lib/api';

const backendBase = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/+$/, '');

function resolveStreamUrl(data) {
  if (!data?.url) return null;
  return data.url.startsWith('http') ? data.url : `${backendBase}${data.url}`;
}

/**
 * Resolve a panel recording stream URL for client report or staff preview.
 * React Query deduplicates by path so cards and modals share the same fetch.
 */
export function usePanelStreamUrl(path) {
  return useQuery({
    queryKey: ['v1-panel-recording-stream', path],
    queryFn: () => v1Get(path),
    enabled: !!path,
    retry: false,
    staleTime: 10 * 60 * 1000,
    select: resolveStreamUrl,
  });
}

/** Build the stream-url API path for a panel recording. */
export function buildPanelStreamUrlPath({ panelId, artifactId, shareToken }) {
  if (!panelId || !artifactId) return null;
  const base = shareToken
    ? `/client-report/${shareToken}/panels/${panelId}/recordings/${artifactId}/stream-url`
    : `/panels/${panelId}/recordings/${artifactId}/stream-url`;
  if (!shareToken || typeof window === 'undefined') return base;
  const email = sessionStorage.getItem(`client-${shareToken}`);
  return email ? `${base}?email=${encodeURIComponent(email)}` : base;
}
